import axios from 'axios'
import Vue from 'vue'
import {login} from "@/api/login";

// let root = 'http://121.199.160.186:12520/';
// let root = 'http://127.0.0.1:12520/';
let root = process.env.VUE_APP_BASEURL;

const server = axios.create({
  baseURL: root,
  timeout: 4000,
  withCredentials:true,
  validateStatus(status){
    return status >= 200 && status < 500;
  }
})

//添加拦截
server.interceptors.request.use(
  config => {
    const sessionid = sessionStorage.getItem('sessionid');
    if (sessionid) {
      config.headers.token=sessionid;
    }
    // config.
    return config
  }, error => {

  });

server.interceptors.response.use(
  response => {
    const res = response.data;
    let config = response.config;
    if (!res.success) {
      if ("nosign" === res.errormsg) {
        // 修改1
        // sessionStorage.removeItem('sessionid');
        // const testuser = {
        //   "uuid":"123",
        //   "name":"用户1"
        // };
        // login(testuser).then(res=>{
        //   if (res.uuid) {
        //     const sessionid = res.sessionid;
        //     sessionStorage.setItem("sessionid",sessionid);
        //   } else {
        //     alert("未登录");
        //   }
        //   location.reload();
        // });
        // location.reload();
      }
    } else {
      return res.data
    }
  }, error => {
    return error;
  });

export default server

/**
 * 封装post请求
 * 传json
 */
export function post(param) {
  // console.log('urlurl',data.url)
  // console.log('datadata',data.data)
  const url = param.url;
  const data = param.data;
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  axios.defaults.baseURL = root;
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}
